const productswiper = new Swiper(".product-detail-swiper", {
  spaceBetween: 20,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slidesPerView: 4
});

const productswiper2 = new Swiper(".product-detail-swiper2", {
  thumbs: {
    swiper: productswiper
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    501: {
      slidesPerView: 1.4,
      spaceBetween: 40,
      centeredSlides: true,
    },
    836: {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
    }
  },
  spaceBetween: 20,
  touchRatio: 2
});